import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AgentApiCandidateMailsShow } from '@/types/serializers';

export default function useRescheduleCandidateMail() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement)?.content ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      mailId,
      scheduledAt,
    }: {
      mailId: number;
      scheduledAt: string;
    }): Promise<AgentApiCandidateMailsShow> => {
      const response = await fetch(`/agent/api/candidate_mails/${mailId}/reschedule`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ candidate_mail: { scheduled_at: scheduledAt } }),
      });

      if (!response.ok) {
        let message = '送信日時の変更に失敗しました。';
        try {
          const data = await response.json();
          const serverMessage = data?.error ?? data?.message ?? data?.errors?.[0];
          if (typeof serverMessage === 'string' && serverMessage.trim().length > 0) {
            message = serverMessage;
          }
        } catch (error) {
          console.error(error);
        }
        throw new Error(message);
      }

      return await response.json();
    },
    onSettled: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ['candidateMails'] }),
        queryClient.invalidateQueries({ queryKey: ['candidateMail'] }),
      ]),
  });
}
